import { Component } from '@grafikr/components';

import { getGender } from 'utils/gender';

export default Component((node) => {
  const update = () => {
    const selectedGender = getGender();

    if (selectedGender !== null) {
      const homepagePath = theme.homepages[selectedGender] as string;
      const url = new URL(location.origin);
      url.pathname = homepagePath;
      node.setAttribute('href', url.href);
    }
  };

  document.addEventListener('gender:updated', update);
  update();
});
